(() => {
  const root = document.querySelector('[data-ln-hajj]');
  if (!root) return;

  const API_URL = (root.dataset.apiUrl || '').replace(/\/$/, '');
  const CONFIRMED_DAY8 = (root.dataset.confirmedDay8 || '').trim();
  const FALLBACK_YEAR = root.dataset.fallbackYear || '2027';
  const DHUL_VIDEO_ID = (root.dataset.dhulVideoId || '').trim();
  const SHOW_PRAYERS = root.dataset.showPrayers === 'true';
  const RIYADH_TZ = 'Asia/Riyadh';

  const $ = (sel, ctx = root) => ctx.querySelector(sel);
  const $$ = (sel, ctx = root) => Array.from(ctx.querySelectorAll(sel));

  const LINKS = {
    dhul: '/blogs/blog-hajj/10-premiers-jours-dhul-hijjah-vertus-que-faire',
    guide: '/blogs/blog-hajj/guide-complet-du-hajj-etape-par-etape',
    day8: '/blogs/blog-hajj/que-faire-le-8-dhul-hijjah-yawm-at-tarwiyah-guide-complet-du-hajj-jour-par-jour',
    mina: '/blogs/blog-hajj/mina-le-coeur-logistique-et-spirituel-du-hajj',
    day9: '/blogs/blog-hajj/que-faire-le-9-dhul-hijjah-jour-de-arafat-guide-complet-du-hajj-jour-par-jour',
    arafat: '/blogs/blog-hajj/arafat-le-coeur-du-hajj-et-le-jour-le-plus-important-de-l-annee',
    muzdalifah: '/blogs/blog-hajj/muzdalifah-que-faire-apres-arafat-guide-complet-du-pelerin-hajj',
    day10: '/blogs/blog-hajj/10-dhul-hijjah-que-faire-le-jour-de-l-aid-pendant-le-hajj',
    jamarat: '/blogs/blog-hajj/jamarat-lapidation-steles-hajj',
    tachriq: '/blogs/blog-hajj/les-jours-de-tachriq-que-faire-les-11-et-12-dhul-hijjah-pendant-le-hajj'
  };

  const STEPS = {
    'dhul-1-7': {
      dayLabel: '1–7 Dhul Hijjah',
      place: 'Dhul Hijjah',
      kicker: 'Avant les rites',
      title: 'Les jours précieux avant le Hajj',
      description: 'Les premiers jours de Dhul Hijjah concernent le pèlerin et le musulman qui reste chez lui. Ici, le calendrier donne seulement les repères essentiels puis renvoie vers le dossier religieux complet.',
      points: [
        'Préserver les obligations et multiplier les bonnes œuvres selon ses capacités.',
        'Dhikr, Coran, invocations, sadaqa et repentir font partie des grandes portes du bien.',
        'Le jeûne volontaire concerne les neuf premiers jours ; le 10 Dhul Hijjah est le jour de l’Aïd.',
        'Le 8 Dhul Hijjah marque ensuite l’entrée dans les rites du Hajj.'
      ],
      source: 'Sahih al-Bukhari 969 ; voir l’article Dhul Hijjah pour les sources et explications complètes.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/10_premiers_jours_de_Dhul_Hijjah-_vertus_et_comment_en_profiter_549f4b98-dfa0-478f-982f-2c35124b7426.png?v=1787121692',
      videoId: DHUL_VIDEO_ID,
      videoTitle: 'Les 10 premiers jours de Dhul Hijjah',
      mainLink: [LINKS.dhul, 'Découvrir les mérites des 10 premiers jours'],
      secondaryLink: [LINKS.guide, 'Voir le Guide complet du Hajj'],
      activePlace: 'makkah'
    },
    day8: {
      dayLabel: '8 Dhul Hijjah',
      place: 'Mina',
      kicker: 'Yawm at-Tarwiyah',
      title: 'Le début effectif des rites',
      description: 'Le pèlerin entre ou reprend son ihram pour le Hajj selon sa situation puis se dirige vers Mina. La journée sert de préparation concrète et spirituelle avant Arafat.',
      points: [
        'Entrer ou reprendre l’ihram pour le Hajj selon le type de pèlerinage.',
        'Multiplier la Talbiyah et se rendre vers Mina.',
        'À Mina : Dhuhr, Asr et Isha sont raccourcies ; elles ne sont pas regroupées.',
        'Passer la nuit à Mina avant le départ vers Arafat.'
      ],
      source: 'Sahih Muslim 1218 ; Sahih al-Bukhari 1549 et 1081. Détails et nuances dans l’article dédié.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/mina_e190dfd2-2a6f-42f6-a058-26aa78cb4b5a.jpg?v=1786291603',
      videoId: 'qZHOa9Li7MI',
      videoTitle: 'Que faire le 8 Dhul Hijjah ?',
      mainLink: [LINKS.day8, 'Comprendre toute la journée du 8 Dhul Hijjah'],
      secondaryLink: [LINKS.mina, 'Découvrir Mina en profondeur'],
      activePlace: 'mina'
    },
    day9: {
      dayLabel: '9 Dhul Hijjah',
      place: 'Arafat',
      kicker: 'Le cœur du Hajj',
      title: 'Le jour de Arafat',
      description: 'Après Mina, les pèlerins se rendent à Arafat. La station à Arafat est une étape fondamentale du Hajj et la journée est consacrée à la prière, au rappel d’Allah et aux invocations.',
      points: [
        'Départ de Mina vers Arafat dans la matinée.',
        'Dhuhr et Asr sont regroupées et raccourcies à l’heure de Dhuhr.',
        'Consacrer l’après-midi au dhikr et aux invocations.',
        'Rester à Arafat jusqu’au coucher du soleil puis partir vers Muzdalifah.'
      ],
      source: 'Sahih Muslim 1218 ; At-Tirmidhi 889 ; Abu Dawud 1949 ; Ibn Majah 3015.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/ARAFAT_016bc715-4843-47cd-9a0a-1e208b9f2562.jpg?v=1786291674',
      videoId: 'uceTCiyl8q0',
      videoTitle: 'Que faire le 9 Dhul Hijjah à Arafat ?',
      mainLink: [LINKS.day9, 'Que faire concrètement le 9 Dhul Hijjah ?'],
      secondaryLink: [LINKS.arafat, 'Comprendre Arafat en profondeur'],
      activePlace: 'arafat'
    },
    night9: {
      dayLabel: 'Nuit du 9 au 10',
      place: 'Muzdalifah',
      kicker: 'Après Arafat',
      title: 'La nuit de Muzdalifah',
      description: 'Après le coucher du soleil à Arafat, le pèlerin rejoint Muzdalifah. Cette nuit constitue une transition courte mais essentielle avant les grands rites du 10 Dhul Hijjah.',
      points: [
        'Quitter Arafat après le coucher du soleil.',
        'À Muzdalifah, regrouper Maghrib et Isha.',
        'Passer la nuit, se reposer et préparer de petits cailloux si nécessaire.',
        'Accomplir Fajr, invoquer Allah puis repartir vers Mina avant le lever du soleil selon la pratique rapportée.'
      ],
      source: 'Coran 2:198 ; Sahih Muslim 1218. Voir le guide Muzdalifah pour les concessions et détails.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/Muzdalifah-9-dul-hijjah_0e947671-d74a-4517-9ab1-0ce2b18c4815.png?v=1787010065',
      videoId: 'mxmsLYXhApU',
      videoTitle: 'Muzdalifah après Arafat',
      mainLink: [LINKS.muzdalifah, 'Comprendre toute l’étape de Muzdalifah'],
      secondaryLink: [LINKS.day10, 'Voir ce qui vient le 10 Dhul Hijjah'],
      activePlace: 'muzdalifah'
    },
    day10: {
      dayLabel: '10 Dhul Hijjah',
      place: 'Mina → Makkah',
      kicker: 'Yawm an-Nahr',
      title: 'Une journée dense, cinq grands repères',
      description: 'Le 10 Dhul Hijjah concentre plusieurs rites majeurs. Le schéma du calendrier présente l’ordre général pour se repérer, sans prétendre rendre cet ordre absolument rigide dans toutes les situations.',
      points: [
        'Jamrat al-Aqabah : 7 petits cailloux.',
        'Sacrifice (Al-Hady) selon le type de Hajj et la situation.',
        'Rasage ou coupe des cheveux.',
        'Tawaf al-Ifadah à La Mecque.',
        'Sa‘i entre Safa et Marwa lorsqu’il reste à accomplir selon le type de Hajj.'
      ],
      source: 'Coran 22:29 ; Sahih Muslim 1218 ; facilités concernant l’ordre rapportées dans al-Bukhari et Muslim.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/jamarat_d40913b1-5000-48f1-a85e-96030dbb346a.jpg?v=1786292695',
      videoId: 'fWMzcZ2wcNc',
      videoTitle: 'Les rites du 10 Dhul Hijjah',
      mainLink: [LINKS.day10, 'Comprendre le 10 Dhul Hijjah en détail'],
      secondaryLink: [LINKS.jamarat, 'Guide complet des Jamarat'],
      activePlace: 'mina'
    },
    day11: {
      dayLabel: '11 Dhul Hijjah',
      place: 'Mina',
      kicker: 'Jours de Tachriq',
      title: 'Premier jour de Tachriq',
      description: 'Les pèlerins demeurent à Mina et poursuivent les rites dans le rappel d’Allah. La lapidation concerne les trois Jamarat dans l’ordre.',
      points: [
        'Lapider la petite Jamarah, puis la moyenne, puis la grande.',
        'Après la petite et la moyenne, prendre le temps d’invoquer Allah.',
        'Poursuivre les prières, le dhikr et les invocations à Mina.'
      ],
      source: 'Coran 2:203 ; hadiths du Hajj rapportés notamment dans Sahih Muslim.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/les-jours-de-tachriq_7058f9b3-33d7-4c59-80cd-68e08db93679.png?v=1786292503',
      videoId: 's35zCpAykeQ',
      videoTitle: 'Les jours de Tachriq',
      mainLink: [LINKS.tachriq, 'Comprendre les jours de Tachriq'],
      secondaryLink: [LINKS.jamarat, 'Guide complet des Jamarat'],
      activePlace: 'mina'
    },
    day12: {
      dayLabel: '12 Dhul Hijjah',
      place: 'Mina',
      kicker: 'Jours de Tachriq',
      title: 'Deuxième jour de Tachriq',
      description: 'Le rite des trois Jamarat se poursuit. Le pèlerin qui choisit le départ anticipé suit les conditions applicables à sa situation et l’organisation de son groupe.',
      points: [
        'Petite Jamarah → moyenne → grande.',
        'Invocations après la petite et la moyenne.',
        'Départ possible pour celui qui se hâte, dans les conditions du rite.'
      ],
      source: 'Coran 2:203 ; voir l’article Tachriq et le guide Jamarat pour les détails.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/les-jours-de-tachriq_7058f9b3-33d7-4c59-80cd-68e08db93679.png?v=1786292503',
      videoId: 's35zCpAykeQ',
      videoTitle: 'Les jours de Tachriq',
      mainLink: [LINKS.tachriq, 'Comprendre le 12 Dhul Hijjah'],
      secondaryLink: [LINKS.jamarat, 'Guide complet des Jamarat'],
      activePlace: 'mina'
    },
    day13: {
      dayLabel: '13 Dhul Hijjah',
      place: 'Mina',
      kicker: 'Dernier jour de Tachriq',
      title: 'Pour ceux qui restent à Mina',
      description: 'Le 13 Dhul Hijjah concerne les pèlerins qui demeurent à Mina après le 12. Ils accomplissent une nouvelle journée de lapidation des trois Jamarat.',
      points: [
        'Lapider à nouveau les trois Jamarat dans l’ordre.',
        'Multiplier le rappel d’Allah et les invocations.',
        'Clore cette séquence du Hajj avec calme et attention.'
      ],
      source: 'Coran 2:203 ; voir l’article Tachriq et le guide Jamarat pour les règles détaillées.',
      image: 'https://cdn.shopify.com/s/files/1/0946/1048/9684/articles/les-jours-de-tachriq_7058f9b3-33d7-4c59-80cd-68e08db93679.png?v=1786292503',
      videoId: 's35zCpAykeQ',
      videoTitle: 'Les jours de Tachriq',
      mainLink: [LINKS.tachriq, 'Comprendre les jours de Tachriq'],
      secondaryLink: [LINKS.jamarat, 'Guide complet des Jamarat'],
      activePlace: 'mina'
    }
  };

  const PLACES = {
    makkah: { label: 'Makkah', lat: 21.4225, lon: 39.8262 },
    mina: { label: 'Mina', lat: 21.4133, lon: 39.8933 },
    arafat: { label: 'Arafat', lat: 21.3549, lon: 39.9841 },
    muzdalifah: { label: 'Muzdalifah', lat: 21.3891, lon: 39.9124 }
  };

  let meta = null;
  let selectedStep = 'dhul-1-7';
  let activePlace = 'makkah';
  let makkahTimings = null;

  function riyadhDateParts(date = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: RIYADH_TZ, year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(date);
    const get = t => parts.find(p => p.type === t)?.value;
    return { year: Number(get('year')), month: Number(get('month')), day: Number(get('day')) };
  }

  function isoFromParts(parts) {
    return `${parts.year}-${String(parts.month).padStart(2, '0')}-${String(parts.day).padStart(2, '0')}`;
  }

  function todayRiyadhISO() { return isoFromParts(riyadhDateParts()); }

  function addDaysISO(iso, days) {
    const d = new Date(`${iso}T12:00:00+03:00`);
    d.setUTCDate(d.getUTCDate() + days);
    return isoFromParts(riyadhDateParts(d));
  }

  function diffDays(aISO, bISO) {
    const a = new Date(`${aISO}T00:00:00+03:00`);
    const b = new Date(`${bISO}T00:00:00+03:00`);
    return Math.round((b - a) / 86400000);
  }

  function hijriParts(date) {
    const parts = new Intl.DateTimeFormat('en-US-u-ca-islamic-umalqura', {
      timeZone: RIYADH_TZ, year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(date);
    const num = type => Number(parts.find(p => p.type === type)?.value);
    return { year: num('year'), month: num('month'), day: num('day') };
  }

  function findEstimatedMeta() {
    const todayISO = todayRiyadhISO();
    const todayMid = new Date(`${todayISO}T12:00:00+03:00`);
    const hp = hijriParts(todayMid);
    let startDate = null;
    let hijriYear = null;

    if (hp.month === 12 && hp.day <= 13) {
      const startISO = addDaysISO(todayISO, -(hp.day - 1));
      startDate = new Date(`${startISO}T12:00:00+03:00`);
      hijriYear = hp.year;
    } else {
      for (let i = 0; i <= 430; i++) {
        const d = new Date(todayMid.getTime() + i * 86400000);
        const h = hijriParts(d);
        if (h.month === 12 && h.day === 1) {
          startDate = d;
          hijriYear = h.year;
          break;
        }
      }
    }

    if (!startDate) throw new Error('Impossible de déterminer Dhul Hijjah.');
    const startISO = isoFromParts(riyadhDateParts(startDate));
    const days = {};
    for (let i = 1; i <= 13; i++) days[i] = addDaysISO(startISO, i - 1);

    return {
      status: 'estimated',
      hijriYear,
      gregorianYear: Number(days[8].slice(0, 4)),
      days,
      source: 'Calendrier Umm al-Qura (estimation navigateur)'
    };
  }

  function metaFromConfirmedDay8(day8ISO) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(day8ISO)) return null;
    const startISO = addDaysISO(day8ISO, -7);
    const days = {};
    for (let i = 1; i <= 13; i++) days[i] = addDaysISO(startISO, i - 1);
    let hy = null;
    try { hy = hijriParts(new Date(`${day8ISO}T12:00:00+03:00`)).year; } catch (_) {}
    return {
      status: 'confirmed',
      hijriYear: hy,
      gregorianYear: Number(day8ISO.slice(0, 4)),
      days,
      source: 'Date confirmée configurée dans LABAYKANUSUK'
    };
  }

  async function loadMeta() {
    if (CONFIRMED_DAY8) {
      const confirmed = metaFromConfirmedDay8(CONFIRMED_DAY8);
      if (confirmed) return confirmed;
    }

    if (API_URL) {
      try {
        const res = await fetch(`${API_URL}/meta`, { headers: { Accept: 'application/json' } });
        if (res.ok) {
          const data = await res.json();
          if (data && data.days && data.days['8']) return data;
        }
      } catch (_) {}
    }

    return findEstimatedMeta();
  }

  function formatDate(iso, opts = {}) {
    if (!iso) return '—';
    return new Intl.DateTimeFormat('fr-FR', {
      timeZone: RIYADH_TZ,
      day: opts.short ? 'numeric' : '2-digit',
      month: opts.short ? 'short' : 'long',
      year: opts.year ? 'numeric' : undefined
    }).format(new Date(`${iso}T12:00:00+03:00`));
  }

  function updateMetaUI() {
    const year = meta?.gregorianYear || FALLBACK_YEAR;
    $('[data-hajj-year]').textContent = year;
    $('[data-hijri-year]').textContent = meta?.hijriYear ? `${meta.hijriYear} H` : 'Dhul Hijjah';

    const status = $('[data-date-status]');
    if (meta?.status === 'confirmed') {
      status.textContent = 'Dates confirmées';
      status.classList.add('is-confirmed');
    } else {
      status.textContent = 'Dates prévisionnelles';
      status.classList.remove('is-confirmed');
    }

    $('[data-day8-date]').textContent = `8 Dhul Hijjah · ${formatDate(meta.days[8], { year: true })}`;

    document.title = `Calendrier du Hajj ${year} : dates, rites et étapes du pèlerinage`;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute('content', `Suivez le calendrier du Hajj ${year}, du 1er au 13 Dhul Hijjah : compte à rebours, étapes, horaires à Makkah, Mina, Arafat et Muzdalifah, vidéos et guides LABAYKANUSUK.`);
    }

    const labels = {
      'dhul-1-7': `${formatDate(meta.days[1], { short: true })} – ${formatDate(meta.days[7], { short: true })}`,
      day8: formatDate(meta.days[8], { short: true }),
      day9: formatDate(meta.days[9], { short: true }),
      night9: `${formatDate(meta.days[9], { short: true })} soir`,
      day10: formatDate(meta.days[10], { short: true }),
      day11: formatDate(meta.days[11], { short: true }),
      day12: formatDate(meta.days[12], { short: true }),
      day13: formatDate(meta.days[13], { short: true })
    };
    Object.entries(labels).forEach(([key, value]) => {
      const el = $(`[data-step-date="${key}"]`);
      if (el) el.textContent = value;
    });
  }

  function updateCountdown() {
    if (!meta) return;
    const target = new Date(`${meta.days[8]}T00:00:00+03:00`);
    const ms = target - new Date();
    const el = $('[data-countdown]');
    if (ms <= 0) {
      const end = new Date(`${addDaysISO(meta.days[13], 1)}T00:00:00+03:00`);
      el.textContent = new Date() < end ? 'En cours' : 'Terminé';
      return;
    }
    const totalHours = Math.floor(ms / 3600000);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    el.textContent = days > 0 ? `${days} j ${hours} h` : `${hours} h`;
  }

  function riyadhHour() {
    return Number(new Intl.DateTimeFormat('en-US', {
      timeZone: RIYADH_TZ, hour: '2-digit', hour12: false
    }).format(new Date()));
  }

  function stepForToday() {
    const today = todayRiyadhISO();
    if (today < meta.days[1]) return 'dhul-1-7';
    if (today >= meta.days[1] && today <= meta.days[7]) return 'dhul-1-7';
    if (today === meta.days[8]) return 'day8';
    if (today === meta.days[9]) return riyadhHour() >= 18 ? 'night9' : 'day9';
    if (today === meta.days[10]) return 'day10';
    if (today === meta.days[11]) return 'day11';
    if (today === meta.days[12]) return 'day12';
    if (today === meta.days[13]) return 'day13';
    return 'dhul-1-7';
  }

  function updateTodayUI() {
    const today = todayRiyadhISO();
    const d = meta.days;

    if (today < d[1]) {
      $('[data-today-kicker]').textContent = 'Prochain Hajj';
      $('[data-today-title]').textContent = `Le Hajj ${meta.gregorianYear} se prépare dès maintenant`;
      $('[data-today-text]').textContent = 'Le calendrier s’ouvrira sur les premiers jours de Dhul Hijjah puis suivra chaque grande étape jusqu’aux jours de Tachriq.';
      $('[data-next-step]').textContent = '1 Dhul Hijjah · début de la période';
      $('[data-next-step-date]').textContent = formatDate(d[1], { year: true });
      return;
    }

    if (today >= d[1] && today <= d[13]) {
      const step = STEPS[stepForToday()];
      $('[data-today-kicker]').textContent = `Aujourd’hui · ${step.dayLabel}`;
      $('[data-today-title]').textContent = step.title;
      $('[data-today-text]').textContent = step.description;
      const dayNum = Math.min(13, Math.max(1, diffDays(d[1], today) + 1));
      const nextDay = Math.min(13, dayNum + 1);
      $('[data-next-step]').textContent = nextDay === dayNum ? 'Fin de la séquence principale' : `${nextDay} Dhul Hijjah`;
      $('[data-next-step-date]').textContent = formatDate(d[nextDay], { year: true });
      return;
    }

    $('[data-today-kicker]').textContent = 'Après le Hajj';
    $('[data-today-title]').textContent = 'Le Hajj de cette année est terminé';
    $('[data-today-text]').textContent = 'Le calendrier reste accessible pour comprendre le parcours et préparer sereinement un prochain Hajj.';
    $('[data-next-step]').textContent = 'Préparer le prochain Hajj';
    $('[data-next-step-date]').textContent = '';
  }

  function renderStep(key, userTriggered = false) {
    const data = STEPS[key];
    if (!data) return;
    selectedStep = key;

    $$('.lnh__step').forEach(btn => {
      const active = btn.dataset.step === key;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    $('[data-focus-day]').textContent = data.dayLabel;
    $('[data-focus-place]').textContent = data.place;
    $('[data-focus-kicker]').textContent = data.kicker;
    $('[data-focus-title]').textContent = data.title;
    $('[data-focus-description]').textContent = data.description;

    const img = $('[data-focus-image]');
    img.src = data.image;
    img.alt = `${data.title} — ${data.place} — LABAYKANUSUK`;

    const ul = $('[data-focus-points]');
    ul.innerHTML = '';
    data.points.forEach(point => {
      const li = document.createElement('li');
      li.textContent = point;
      ul.appendChild(li);
    });

    $('[data-focus-source]').textContent = data.source;

    const main = $('[data-focus-link-main]');
    main.href = data.mainLink[0];
    main.textContent = data.mainLink[1];

    const secondary = $('[data-focus-link-secondary]');
    if (data.secondaryLink) {
      secondary.href = data.secondaryLink[0];
      secondary.textContent = data.secondaryLink[1];
      secondary.hidden = false;
    } else {
      secondary.hidden = true;
    }

    const shell = $('[data-video-shell]');
    const frame = $('[data-video-frame]');
    if (data.videoId) {
      shell.hidden = false;
      $('[data-video-title]').textContent = data.videoTitle;
      frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(data.videoId)}?rel=0`;
      frame.title = data.videoTitle;
    } else {
      shell.hidden = true;
      frame.src = '';
    }

    if (SHOW_PRAYERS) setActivePlace(data.activePlace, true);

    if (userTriggered && window.matchMedia('(max-width: 680px)').matches) {
      $('.lnh__focus')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function updateMakkahClock() {
    const value = new Intl.DateTimeFormat('fr-FR', {
      timeZone: RIYADH_TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).format(new Date());
    $('[data-makkah-clock]').textContent = value.slice(0, 5);
    const placeClock = $('[data-place-clock]');
    if (placeClock) placeClock.textContent = value.slice(0, 5);
    updateNextPrayer();
  }

  function cleanTime(value) {
    return String(value || '').replace(/\s*\(.+?\)\s*/g, '').trim().slice(0, 5);
  }

  function todayCacheKey(place) {
    return `lnh-prayers-v1:${place}:${todayRiyadhISO()}`;
  }

  async function getTimings(placeKey) {
    const cachedKey = todayCacheKey(placeKey);
    try {
      const cached = JSON.parse(localStorage.getItem(cachedKey) || 'null');
      if (cached && cached.expires > Date.now() && cached.timings) return cached.timings;
    } catch (_) {}

    let timings = null;

    if (API_URL) {
      try {
        const res = await fetch(`${API_URL}/timings?place=${encodeURIComponent(placeKey)}`, {
          headers: { Accept: 'application/json' }
        });
        if (res.ok) {
          const data = await res.json();
          timings = data.timings || data.data?.timings || null;
        }
      } catch (_) {}
    }

    if (!timings) {
      const place = PLACES[placeKey];
      const timestamp = Math.floor(Date.now() / 1000);
      const url = new URL(`https://api.aladhan.com/v1/timings/${timestamp}`);
      url.searchParams.set('latitude', place.lat);
      url.searchParams.set('longitude', place.lon);
      url.searchParams.set('method', '4');
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error('Horaires indisponibles');
      const data = await res.json();
      timings = data?.data?.timings;
    }

    if (!timings) throw new Error('Horaires indisponibles');

    try {
      localStorage.setItem(cachedKey, JSON.stringify({
        timings, expires: Date.now() + 6 * 3600000
      }));
    } catch (_) {}

    return timings;
  }

  async function setActivePlace(placeKey) {
    if (!PLACES[placeKey]) return;
    activePlace = placeKey;
    $$('.lnh__place-tabs button').forEach(btn => btn.classList.toggle('is-active', btn.dataset.place === placeKey));

    const label = $('[data-prayer-place]');
    if (label) label.textContent = PLACES[placeKey].label;
    const status = $('[data-prayer-status]');
    if (status) status.textContent = 'Chargement des horaires…';

    try {
      const timings = await getTimings(placeKey);
      ['Fajr', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'].forEach(name => {
        const el = $(`[data-prayer="${name}"]`);
        if (el) el.textContent = cleanTime(timings[name]);
      });
      if (status) status.textContent = 'Méthode Umm Al-Qura · horaires indicatifs';
      if (placeKey === 'makkah') {
        makkahTimings = timings;
        updateNextPrayer();
      }
    } catch (_) {
      if (status) status.textContent = 'Horaires momentanément indisponibles.';
    }
  }

  async function preloadMakkahTimings() {
    try {
      makkahTimings = await getTimings('makkah');
      updateNextPrayer();
    } catch (_) {
      $('[data-makkah-next]').textContent = 'Horaires Makkah indisponibles';
    }
  }

  function timeToMinutes(t) {
    const [h, m] = cleanTime(t).split(':').map(Number);
    return Number.isFinite(h) && Number.isFinite(m) ? h * 60 + m : null;
  }

  function updateNextPrayer() {
    if (!makkahTimings) return;
    const nowParts = new Intl.DateTimeFormat('en-US', {
      timeZone: RIYADH_TZ, hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    const h = Number(nowParts.find(p => p.type === 'hour')?.value);
    const m = Number(nowParts.find(p => p.type === 'minute')?.value);
    const nowMin = h * 60 + m;
    const names = ['Fajr', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'];
    const next = names
      .map(name => ({ name, time: cleanTime(makkahTimings[name]), min: timeToMinutes(makkahTimings[name]) }))
      .find(p => p.min !== null && p.min > nowMin);

    $('[data-makkah-next]').textContent = next
      ? `Prochaine prière : ${next.name} · ${next.time}`
      : `Prochaine prière : Fajr · ${cleanTime(makkahTimings.Fajr)}`;
  }

  function shareCalendar() {
    const data = STEPS[selectedStep];
    const year = meta?.gregorianYear || FALLBACK_YEAR;
    const text = `${data.dayLabel} — ${data.title}. Découvrez le Calendrier du Hajj ${year} avec LABAYKANUSUK.`;

    if (navigator.share) {
      navigator.share({ title: `Calendrier du Hajj ${year}`, text, url: location.href }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(`${text} ${location.href}`).then(() => {
        const btn = $('[data-share]');
        const old = btn.textContent;
        btn.textContent = 'Lien copié';
        setTimeout(() => btn.textContent = old, 1800);
      }).catch(() => {});
    }
  }

  function bindEvents() {
    $$('.lnh__step').forEach(btn => btn.addEventListener('click', () => renderStep(btn.dataset.step, true)));
    $$('.lnh__place-tabs button').forEach(btn => btn.addEventListener('click', () => setActivePlace(btn.dataset.place)));
    $('[data-print]')?.addEventListener('click', () => window.print());
    $('[data-share]')?.addEventListener('click', shareCalendar);
  }

  async function init() {
    bindEvents();
    updateMakkahClock();
    setInterval(updateMakkahClock, 1000);

    try { meta = await loadMeta(); }
    catch (_) { meta = findEstimatedMeta(); }

    updateMetaUI();
    updateCountdown();
    setInterval(updateCountdown, 60000);
    updateTodayUI();

    selectedStep = stepForToday();
    renderStep(selectedStep);

    if (SHOW_PRAYERS) {
      preloadMakkahTimings();
      setActivePlace(STEPS[selectedStep].activePlace);
    }
  }

  init();
})();
